export const PORTFOLIO_ANALYTICS_PRO_ADDON_ID = 1;
